import { Helmet } from "react-helmet-async";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import Values from "@/components/Values";
import Services from "@/components/Services";
import ServiceAreas from "@/components/ServiceAreas";
import AboutUs from "@/components/AboutUs";
import Clients from "@/components/Clients";
import Process from "@/components/Process";
import Projects from "@/components/Projects";
import Testimonials from "@/components/Testimonials";
import Lighting from "@/components/Lighting";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <>
      <Helmet>
        <title>MYCING - Soluciones Eléctricas Industriales y Comerciales en Chile</title>
        <meta name="description" content="MYCING: Empresa líder en ingeniería eléctrica con más de 15 años de experiencia. Instalaciones industriales, mantención eléctrica, normalización SEC y automatización. +200 proyectos completados en Chile." />
        <link rel="canonical" href="https://mycing.cl/" />
        <meta property="og:title" content="MYCING - Soluciones Eléctricas Industriales y Comerciales en Chile" />
        <meta property="og:description" content="Empresa líder en ingeniería eléctrica con más de 15 años de experiencia. Instalaciones industriales, mantención, normalización SEC. +200 proyectos completados." />
        <meta property="og:url" content="https://mycing.cl/" />
      </Helmet>
      <div className="min-h-screen">
        <Navigation />
        <Hero />
        <Values />
        <Clients />
        <Services />
        <ServiceAreas />
        <AboutUs />
        <Process />
        <Projects />
        <Testimonials />
        <Lighting />
        <Contact />
        <Footer />
      </div>
    </>
  );
};

export default Index;
